import styled from "styled-components";
import { BREAKPOINTS } from "../../../../../app/appConstants";

export const CashierWrapperSliderHeaderStyled = styled.div`
    padding: 32px 16px 24px;
    display: flex;
    justify-content: center;
    color: var(--color-white-60);
    min-height: 60px;
    font-weight: 700;

    svg {
        fill: var(--color-white-60);
    }
`;

export const CashierWrapperStyled = styled.div`
    padding: 20px 20px 0;
    
    @media (max-width: ${BREAKPOINTS.medium}px) {
        padding: 0;
    }
`;

export const CashierWrapperHeaderStyled = styled.div`
    font-size: 16px;
    padding: 16px;
    font-weight: 700;
    display: flex;
    align-items: center;
    
    div {
        cursor: pointer;
    }

    svg {
        fill: var(--color-secondary);
    }
`;

export const CashierWrapperBackSliderStyled = styled.div`
    position: absolute;
    left: 16px;
    cursor: pointer;
    display: flex;
`;
